import React from 'react';

import { getQuestTiers, isTieredChallenge } from '../../loyalty-quest/utils';

import { RegularSteps } from './regular-steps';
import { TieredSteps } from './tiered-steps/tiered-steps';
import { IQuestStepsProps } from './types';

export const QuestSteps = ({
  cmsQuestRequirementById,
  cmsQuestDetail,
  cmsQuestDetailUI,
  quest,
  onCloseDrawer,
}: IQuestStepsProps) => {
  if (!quest || !quest?.steps) {
    return null;
  }

  const tiers = getQuestTiers(quest);
  const shouldRenderTieredSteps = isTieredChallenge({ quest, tiers });

  const commonProps = {
    quest,
    cmsQuestRequirementById,
    cmsQuestDetailUI,
    onCloseDrawer,
  };

  if (shouldRenderTieredSteps) {
    // Tiered quests carry per-step CMS data nested under each tier.
    const cmsTiers = cmsQuestDetail?.questRules?.tiers ?? [];
    return <TieredSteps tiers={tiers} cmsTiers={cmsTiers} {...commonProps} />;
  }

  // For regular (non-tiered) quests `getQuestTiers` returns a single tier
  // whose `bonusPoints` already falls back to `quest.bonusPoints`. The CMS
  // exposes their step metadata as a flat list under `questRules.steps`.
  const [tier] = tiers;
  if (!tier) {
    return null;
  }

  const cmsSteps = cmsQuestDetail?.questRules?.steps ?? [];
  return <RegularSteps tier={tier} cmsSteps={cmsSteps} {...commonProps} />;
};
